import { Component } from 'react';

import { VoidInterface } from 'types/functions';
import { twclsx } from 'utils/twclsx';

import Icon from './Icon';

interface MenuGroupComponentProps {
    title: string;
    className?: string;
    active?: boolean;
    settings?: VoidInterface;
    sticky?: boolean;
    extrnal?: boolean;
    open?: boolean;
    showArrow?: boolean;
    callback?: (state: boolean) => void;
    children?: string | JSX.Element | JSX.Element[];
}

interface MenuGroupComponentState {
    active: boolean;
}

class MenuGroup extends Component<MenuGroupComponentProps, MenuGroupComponentState> {
    constructor(props: MenuGroupComponentProps) {
        super(props);
        this.state = {
            active: props.active !== undefined ? props.active : false,
        };
    }

    static getDerivedStateFromProps(props: MenuGroupComponentProps, state: MenuGroupComponentState) {
        if (props.extrnal && props.active !== state.active) {
            return {
                active: props.active,
            };
        }
        return null;
    }

    toggleMenu = () => {
        if (this.props.extrnal) {
            //@ts-ignore
            this.props?.callback(!this.state.active);
        } else {
            this.setState({ active: !this.state.active }, () => {
                if (!this.props?.callback) {
                    return;
                }
                this.props?.callback(this.state.active);
            });
        }
    };

    render() {
        const { className, children, title, sticky, showArrow } = this.props;

        return (
            <div className={twclsx('flex', 'flex-col', this.state.active && 'border-b', 'border-gray-300', className)}>
                <div
                    className={twclsx(
                        'flex',
                        'justify-between',
                        !this.state.active && 'border-b',
                        'py-2',
                        'border-gray-300',
                        sticky && 'sticky',
                        sticky && 'bg-white',
                        'top-0',
                        'px-2',
                        'z-10'
                    )}
                >
                    <div className="font-bold no-select bg-white">{title}</div>
                    <div className="flex gap-2 items-start">
                        {this.props.settings && (
                            <div onClick={this.props.settings} className="cursor-pointer">
                                <Icon className="h-4 w-4 mt-0.5">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                    <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z" />
                                    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0" />
                                </Icon>
                            </div>
                        )}
                        {this.props.showArrow && !this.props.open && (
                            <div onClick={this.toggleMenu} className="cursor-pointer">
                                {this.state.active ? (
                                    <Icon>
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M6 15l6 -6l6 6" />
                                    </Icon>
                                ) : (
                                    <Icon>
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M6 9l6 6l6 -6" />
                                    </Icon>
                                )}
                            </div>
                        )}
                    </div>
                </div>
                {this.state.active && <div className="px-2">{children}</div>}
            </div>
        );
    }
}

export default MenuGroup;
